import '.cd{margin-right:-1rem;}.ssr-plugin'
import { Avatar, AvatarSize } from '@app/components/core/avatar/Avatar'
import { Text } from '@app/components/core/typography/Text'
import Row from '@app/components/layout/Row'
import { fullName } from '@app/util/helpers'
import { Style, styled } from 'inlines'
import { useMemo } from 'react'

const avatarVariants: ('pink' | 'yellow' | 'dimmed-red')[] = [
  'pink',
  'dimmed-red',
  'yellow',
  'pink',
  'yellow',
  'dimmed-red',
]

export type ProfileAvatar = {
  firstName: string
  lastName: string
  middlePart?: string
  avatar?: string | { src: string }
}

export type AvatarStackProps = {
  size: AvatarSize
  avatars: ProfileAvatar[]
  total?: number
  style?: Style
  version?: 'light' | 'dark'
  onClick?: VoidFunction
}

export const AvatarStack = ({
  size = 'medium',
  avatars,
  total,
  style,
  version = 'dark',
  onClick,
}: AvatarStackProps) => {
  const { avatarsSliced, totalSlicedAvatars, moreFollowers } = useMemo(() => {
    const avatarsSliced = avatars.slice(0, 5)
    const totalSlicedAvatars = avatarsSliced.length
    const moreFollowers = (total || avatars.length) - totalSlicedAvatars

    return { avatarsSliced, totalSlicedAvatars, moreFollowers }
  }, [avatars, total])

  if (!avatars || avatars.length === 0) {
    return null
  }

  const color =
    version === 'dark' ? 'var(--palette-blue-500)' : 'var(--palette-white)'

  return (
    <Row
      gap="0rem"
      style={{
        alignItems: 'center',
        cursor: onClick ? 'pointer' : 'inherit',
        marginRight: moreFollowers > 0 ? 0 : '1rem',
        ...style,
      }}
    >
      {avatarsSliced.map((follower, index) => (
        <div className="cd"
          key={index}
          onClick={onClick}
        >
          <Avatar
            labelSource={fullName(follower)}
            image={follower.avatar}
            variant={avatarVariants[index]}
            size={size}
          />
        </div>
      ))}
      {moreFollowers > 0 && (
        <Text.Small
          color={color}
          style={{ marginLeft: `${totalSlicedAvatars * 0.25}rem` }}
        >{`+ ${moreFollowers}`}</Text.Small>
      )}
    </Row>
  )
}
